import React from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { DATE_FORMAT } from 'utils/constants';
import CreateActivityForm, {
  CreateActivityFields,
} from 'v2/common/CreateActivityModal/CreateActivityForm';
import FormModal from 'v2/common/FormModal/FormModal';
import { ActivityAssociation } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

interface InteractionsActivityFormProps {
  defaultAssociations: ActivityAssociation[];
  onCloseForm: () => void;
  show: boolean;
  onHide: () => void;
}

const InteractionsActivityForm = ({
  defaultAssociations,
  onCloseForm,
  show,
  onHide,
}: InteractionsActivityFormProps) => {
  const formContext = useForm<CreateActivityFields>({
    mode: 'onChange',
    defaultValues: {
      relationships: defaultAssociations,
    },
  });
  const { reset } = formContext;

  const closeForm = () => {
    reset({
      description: '',
      type: { label: '', value: '' },
    });
    onCloseForm();
  };

  const { isLoading, mutate: saveActivityMutation } = useMutation({
    mutationFn: async (data: CreateActivityFields) => {
      const cleanedData = {
        ...data,
        relationships: data.relationships.filter(
          (rel) => rel.selected || rel.is_mandatory
        ),
        timestamp: data.timestamp?.format(DATE_FORMAT.STANDARD_TIME),
        type: data.type?.value,
      };
      await restFactory.post(`/dj/api/v1/activity/`, cleanedData);
    },
    onSuccess: () => {
      closeForm();
      toast.success('New activity saved.');
    },
    onError: () => {
      toast.error('Error saving activity.');
    },
  });

  const handleSubmit = (data: CreateActivityFields) => {
    saveActivityMutation(data);
  };

  return (
    <FormModal
      show={show}
      title={'Add a New Activity'}
      onCancel={closeForm}
      onClose={onHide}
      onSubmit={handleSubmit}
      formContext={formContext}
      isLoading={isLoading}
      animation={false}
    >
      <CreateActivityForm defaultAssociations={defaultAssociations} />
    </FormModal>
  );
};

export default InteractionsActivityForm;
